import { DOCUMENT } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { Router } from '@angular/router';
import { BACK_NAVIGATION_EXCEPTIONS } from '@app/core/constance';
import { CommunityNavigationService } from '@outlaw/community';
import { DataTestDirective, NavigationService } from '@outlaw/core';

@Component({
  selector: 'app-button-back',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss'],
  imports: [DataTestDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BackButtonComponent {
  public readonly router = inject(Router);
  private readonly communityNavigationService = inject(
    CommunityNavigationService,
  );
  private readonly navigationService = inject(NavigationService);
  private readonly document = inject(DOCUMENT);

  @Input() text = 'Back';
  @Input() withBg = false;
  @Input() straight = false;
  @Input() straightUrl = '/';

  openPreviousOrHome(): void {
    if (this.straight || history.length <= 2) {
      const [path, params] = this.getQueryParams(this.straightUrl);
      const hasQueryParams = Object.keys(params).length > 0;
      if (hasQueryParams) {
        this.router.navigate([path], { queryParams: params });
        return;
      }

      this.router.navigate([path]);
      return;
    }

    if (this.isPreviousPathException()) {
      const navigationContext =
        this.communityNavigationService.getNavigationContext();

      if (navigationContext) {
        this.router.navigate([navigationContext.returnUrl]);
        this.communityNavigationService.clearNavigationContext();
        return;
      }

      this.navigationService.goToFeed();
    }

    history.back();
  }

  private getQueryParams(
    url: string,
  ): [path: string, params: { [key: string]: string }] {
    const [path, queryParams] = url.split('?');
    const hasQueryParams = queryParams && queryParams.length > 0;
    if (hasQueryParams) {
      const params: { [key: string]: string } = {};
      queryParams.split('&').forEach((param) => {
        const [key, value] = param.split('=');
        params[key] = value;
      });
      return [path, params];
    }

    return [path, {}];
  }

  private isPreviousPathException(): boolean {
    const referrer = this.document.referrer;

    return BACK_NAVIGATION_EXCEPTIONS.some((exception) =>
      referrer.includes(exception),
    );
  }
}
